import './App.css';
import Faq from './components/Faq';
import Hero from './components/Hero';
import History from './components/History';
import Roadmap from './components/Roadmap';
import Team from './components/Team';
import Footer from './components/Footer';
import Diamonds from './components/Diamonds';


function App() {
  return (
    <div className="App">
      <Hero />
      <History />
      <Roadmap />
      <Diamonds />
      <Faq />
      <Team />
      <Footer />
    </div>
  );
}

export default App;
